import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Button, Spinner, Alert, Badge } from 'react-bootstrap';
import { apiGet } from '../services/apiClient';

const statusVariant = {
  active: 'success',
  inactive: 'secondary',
};

const typeVariant = {
  api: 'primary',
  ical: 'info',
  webhook: 'warning',
};

const ChannelProvidersPage = ({ token }) => {
  const navigate = useNavigate();
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await apiGet('/api/admin/channel/providers', token);
      setProviders(data || []);
    } catch (err) {
      setError(err.message || 'Failed to load providers');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p-4 bg-white rounded shadow-sm">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <h4 className="mb-0">API Management - Providers</h4>
          <small className="text-muted">Supported channel partners and data feeds.</small>
        </div>
        <Button
          variant="primary"
          onClick={() => navigate('/admin/channel/connections')}
        >
          + Add Connection
        </Button>
      </div>

      {loading && (
        <div className="py-4 text-center">
          <Spinner animation="border" />
        </div>
      )}
      {error && <Alert variant="danger">{error}</Alert>}

      {!loading && (
        <Table bordered hover responsive className="align-middle">
          <thead className="table-light">
            <tr>
              <th>Name</th>
              <th>Key</th>
              <th>Type</th>
              <th>Status</th>
              <th>Docs</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {providers.map((provider) => (
              <tr key={provider.id}>
                <td className="fw-semibold">{provider.name}</td>
                <td>{provider.key}</td>
                <td>
                  <Badge bg={typeVariant[provider.type] || 'secondary'}>{provider.type}</Badge>
                </td>
                <td>
                  <Badge bg={statusVariant[provider.status] || 'secondary'}>{provider.status}</Badge>
                </td>
                <td>
                  {provider.docs_url ? (
                    <a href={provider.docs_url} target="_blank" rel="noreferrer">
                      View docs
                    </a>
                  ) : (
                    <span className="text-muted">—</span>
                  )}
                </td>
                <td>
                  <Button
                    size="sm"
                    variant="outline-primary"
                    onClick={() => navigate(`/admin/channel/providers/${provider.id || provider.key}`)}
                  >
                    Manage
                  </Button>
                </td>
              </tr>
            ))}
            {!providers.length && (
              <tr>
                <td colSpan={6} className="text-center text-muted">
                  No providers configured.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default ChannelProvidersPage;
